import React from 'react'
import { Create } from 'react-admin'
import SectionWrapper from 'ui-shared/LayoutComponents/SectionWrapper'
import ProfessionalSectionForm from './ProfessionalSectionForm'

const ProfessionalSectionCreate: React.FC = () => (
  <SectionWrapper>
    <Create>
      <ProfessionalSectionForm />
    </Create>
  </SectionWrapper>
)

export default ProfessionalSectionCreate
